<template>
  <a-row :gutter="{ xs: 0, lg: 8 }">
    <a-col :xs="24" :lg="8">
      <a-card>
        <span class="m-text-title" slot="title">Filter</span>
        <div class="d-flex flex-column">
          <a-input-search v-model="search" placeholder="Pencarian ... " />
          <a-collapse activeKey="1" class="m-top">
            <a-collapse-panel key="1">
              <span slot="header">Cari Lebih Lengkap</span>
              <div class="m-form-item-wrapper">
                <label for="tanggalTransaksi">Tanggal Transaksi</label>
                <a-range-picker
                  v-model="transactionDt"
                  @change="searching"
                  :format="getDefaultDateFormat"
                  allowClear
                />
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-card>
    </a-col>
    <a-col :xs="24" :lg="16">
      <H-Datalist
        :title="isMobile ? 'Alokasi Manager' : 'Rekap Beban Cost Center'"
        createLink="create-bebanCostCenter"
        manifestLink="manifest-bebanCostCenter"
        :dataList="dataFormatted"
        :createDisable="statusEntry ? false : true"
      >
      </H-Datalist>
    </a-col>
  </a-row>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import DataList from "@/components/Datalist";

export default {
  name: "list-cost-center",
  components: {
    "H-Datalist": DataList,
  },
  data() {
    return {
      datalist: [],
      search: "",
      transactionDt: [],
      statusEntry: false,
    };
  },
  computed: {
    ...mapGetters(["getDefaultDateFormat"]),
    searching() {
      let output = this.datalist;
      if (this.search) {
        output = this.datalist.filter(
          (item) =>
            item.no_rekap.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            item.departemen.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            item.posisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.site.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.description.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            item.akhir_periode
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            item.awal_periode
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.transactionDt.length > 0) {
        let startDt = moment(this.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(this.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        output = this.datalist.filter(
          (obj) => obj.awal_periode >= startDt && obj.akhir_periode <= endDt
        );
      }

      return output;
    },
    dataFormatted() {
      let output = [];

      this.searching.forEach((data) => {
        output.push({
          title: data.no_rekap,
          subdesc: [
            this.moment(data.awal_periode).format(this.getDefaultDateFormat) +
              " - " +
              this.moment(data.akhir_periode).format(this.getDefaultDateFormat),
            data.departemen + " | " + data.posisi,
            data.site,
          ],
          description: data.description,
          id: data.id_rekap,
        });
      });

      return output;
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    moment,
    fetch() {
      this.$store.dispatch("getCostList").then((res) => {
        this.datalist = res.list;
        this.statusEntry = res.status_entry;
      }).catch(err=>{
          if (err.response.status === 400) {
              this.statusEntry = err.response.data.status_entry;
          }
      });
    },
  },
};
</script>

<style></style>
